import { useCallback, useContext, useState } from 'react';
import { useComet, useMutation } from 'shared/api/hooks';
import { useCallbacks } from 'shared/hooks/utils';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function useUpdateRfIndicators() {
    const { device_id } = useContext(DeviceConfig);
    const [onRequest] = useMutation('rf_load_devices', {
        device_id,
    });
    const [is_loading, setIsLoaded, setIsLoading] = useBooleanState(false);
    const [response, setResponse] = useState([]);
    const onReceiveResponse = useCallback((response) => {
        setIsLoaded();
        setResponse(response.rf2);
    }, []);
    useComet({
        event: 'rf_load_devices_response',
        condition: { device_id },
        callback: onReceiveResponse,
    });
    const onRequestRf = useCallbacks([setIsLoading, onRequest]);
    return [onRequestRf, is_loading, response];
}
